import { render, staticRenderFns } from "./BackspaceOutline.vue?vue&type=template&id=466cb96c"
import script from "./BackspaceOutline.vue?vue&type=script&lang=js"
export * from "./BackspaceOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports